import { Checkbox, Form, Typography } from 'antd';
import React from 'react';
import styles from './index.module.scss';

const PRIVACY_URL = '/agreement/privacy.html';
const USER_URL = '/agreement/user.html';
const ACCOUNT_URL = '/agreement/accountUsage.html';

const LoginAgreement: React.FC<{ name?: string }> = ({ name = 'agreement' }) => {
  return (
    <Form.Item
      name={name}
      valuePropName="checked"
      className={styles.agreementItem}
      validateTrigger="onChange"
      rules={[
        {
          validator: (_, value) => (value ? Promise.resolve() : Promise.reject(new Error('请阅读并同意相关条款及协议')))
        }
      ]}
    >
      <div className={styles.agreement}>
        <Checkbox></Checkbox>

        <div style={{ fontSize: '12px', marginLeft: '10px' }}>
          已阅读并同意
          <Typography.Link target="_blank" href={PRIVACY_URL}>
            《MAXHUB账号使用协议》
          </Typography.Link>
          、
          <Typography.Link target="_blank" href={USER_URL}>
            《用户协议》
          </Typography.Link>
          和
          <Typography.Link target="_blank" href={ACCOUNT_URL}>
            《隐私政策》
          </Typography.Link>
        </div>
      </div>
    </Form.Item>
  );
};

export default LoginAgreement;
